import { render, staticRenderFns } from "./SetsCloseTime.vue?vue&type=template&id=0a71835a&scoped=true&"
import script from "./SetsCloseTime.vue?vue&type=script&lang=js&"
export * from "./SetsCloseTime.vue?vue&type=script&lang=js&"
import style0 from "./SetsCloseTime.vue?vue&type=style&index=0&id=0a71835a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71835a",
  null
  
)

export default component.exports